<template>
    <div class="ml-2">
        <b-button variant="danger" @click.stop="abrirModal()"
            ><i class="fa fa-times-circle"></i> Cancelar</b-button
        >
        <encaminhamento-form
            titulo="Cancelar Requisição"
            operacao="C"
            :dados="dadosCancelamento"
            :requisicao="requisicao"
            :erros="erros"
            :mostrarModal="mostrarModal"
            @fecharModal="fecharModal()"
            @salvar="cancelarRequisicao($event)"
        ></encaminhamento-form>
    </div>
</template>

<script>
import EncaminhamentoForm from './EncaminhamentoForm'
import RequisicoesServicos from './RequisicoesServicos'

export default {
    props: {
        requisicao: {
            type: Object
        }
    },

    components: {
        EncaminhamentoForm
    },

    data() {
        return {
            erros: [],
            mostrarModal: false,
            dadosCancelamento: null
        }
    },

    methods: {
        fecharModal() {
            this.mostrarModal = false
        },

        abrirModal() {
            this.obterDadosCancelamento()
        },

        obterDadosCancelamento() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterDadosCancelamento(
                this.$route.params.idRequisicao
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.dadosCancelamento = response.data
                    } else {
                        this.erros = [
                            'Erro ao obter dados do cancelamento da requisição'
                        ]
                    }
                }
                this.$store.dispatch('removeRequest')
                this.mostrarModal = true
            })
        },

        cancelarRequisicao(cancelamento) {
            this.$store.dispatch('addRequest')
            cancelamento.idRequisicao = this.requisicao.idRequisicao
            RequisicoesServicos.cancelar(cancelamento).then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('obterRequisicaoAtualizada')
                        this.$store.dispatch('setRecarregar', true)
                        this.$toast.success(
                            'Requisição cancelada com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.mostrarModal = false
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {},

    created() {}
}
</script>
